import { LOCALE_DEFAULT } from '@model/const/locales';

// Regional English has no TI blog content of its own, these locales mirror en-us
const MIRRORED_LOCALES = new Set(['en-eu', 'en-gb', 'en-sg']);

export function getTrueImageBlogContentLocale(locale: string): string {
    return MIRRORED_LOCALES.has(locale) ? LOCALE_DEFAULT : locale;
}

export function getTrueImageBlogCanonicalPath(path: string, locale: string): string {
    return path.replace(`/${locale}/`, `/${getTrueImageBlogContentLocale(locale)}/`);
}
